import { TruckCheckIcon } from './TruckCheckIcon';

/**
 * author: Austin Andrews
 * id 39C645BD-15AE-42BE-B571-5744CB77E97D
 * name truck-check
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/truck-check.svg
 * tags
 * - Transportation + Road 
 */
export const CourierCheckIcon = TruckCheckIcon;
export default CourierCheckIcon